import axios from "axios";

var lang = (document.querySelector('#revenge-bet-console').getAttribute('lang')) ? document.querySelector('#revenge-bet-console').getAttribute('lang') : process.env.VUE_APP_FALLBACK_LOCALE

if (lang.includes('-')) {
    const langSplit = lang.split('-');
    lang = langSplit[0];
}

if (lang.includes('_')) {
    const langSplit = lang.split('_');
    lang = langSplit[0];
}

const state = {
    name: 'Revenge BetConsole',
    urlApi: process.env.VUE_APP_URL_API,
    betApiUrl: process.env.VUE_APP_BET_API_URL,
    urlRules: process.env.VUE_APP_URL_RULES,
    platform_id: (document.querySelector('#revenge-bet-console').getAttribute('platform') != "0") ? document.querySelector('#revenge-bet-console').getAttribute('platform') : 0,
    token: '',
    language: lang,
    snackbar: false,
    snackbar_text: '',
    platform_settings: [],
    results: [],
    banners: [],
    showquickbet: false, // true for  move directly to quick bet page for agency
    nextevent: false,
    eventday: false,
    cashout: false,
    cashoutlive: false,
    // betFreeze master gate (SkinConfig.enableBetFreeze). rocky-bets enforces it
    // server-side too — this only decides whether the UI asks for a preview.
    betFreeze: false,
    voidAsLose: false,
    electron: false,
    icon: "icons",
    gameConsole: 'default',
    stream_live: false,
    enable_central_banner: true,
    featuredTournamentAutoLoad: false,
    featuredTournamentWidget: false,
    featuredTournamentsInfo: [],
    programOpen: false,
    shortCode: false,
    enableClearCartAtPlaceBet: false,
    enabledTaxOnWon: false,
    percentageTaxValueOnWon: 0,
    enableAgencyCanPlayForUser: false,
    // Skin flag: playing on behalf of a user, the agency may top up the user's balance
    // ("Automatic recharge"). Not the switch itself: that is enableAutoRecharge.
    enableAgencyAutoRecharge: false,
    // Skin flag: a cashier may play on behalf of the players of its agency (no automatic recharge)
    enableCashierCanPlayForUser: false,
    enableAgencyCashout: false,
    enableCashierCashout: false,
    enableTerminalCashout: false,
    enableMobileBottomToolbar: false,
    explodeMarketOnMobileDevice: false,
    proxyUrl: null,
    website: null,
    enableAutoRecharge: false,
    customerId: null,
    showMultiplicityLegendMobile: false,
    enableTreeWithPlayerOutcomes: false,
    quickBetEnabled: false,
    allowIntegralLiveBet: false,
    cashoutPollIntervalMs: 60000,
    livePollingIntervalMs: 45000,
    finishedEventRemovalMs: 300000,
    liveScorePollingIntervalMs: 10000,
    liveDetailOddsRefreshIntervalMs: 45000,
    enableEarlyPayout: true,
    enableMostPlayedWidget: true,
    enableUserTracking: false,
    enableNextEventsWidget: true,
    enableStartingSoonWidget: true,
    uiPersonalizationLeft: null,
    uiPersonalizationCenter: null,
    uiPersonalizationRight: null,
    uiPersonalizationGeneral: null,
    timeFilterSteps: null,
    mobileKeypadType: "virtual",
    showParticipantLogos: true,
    showTournamentLogos: true,
    // TODO API: sostituire con dati provenienti dall'API quando disponibili
    marketConfig: {
        correctScoreIds: [6, 9, 100, 428, 556, 3200, 3309, 3310],
        onlyCorrectScoreIds: [6, 9, 100, 556, 3200, 3309, 3310],
        handicapIds: [3]
    },

    livePreviewMaxEvents: 100,
    liveDetailMaxMarkets: 500,
    prematchPreviewMaxEvents: 15,
    prematchDetailMaxMarkets: 150,
    mostPlayedMaxEventsForPage: 10,
    nextEventsMaxEventsForPage: 10,
    startingSoonMaxEventsForPage: 10,
    liveNowPreviewMaxEventsForPage: 10,
    maxMixedEventsForPage: 50,
    timeToWaitToCallTournamentLive: 5000,
    enableQuickBetOnlyForAgency: false,
    enableBetBuilder: false,
    // Bet builder on live events (skin enableLiveBetBuilder, DataSavage engine only).
    enableLiveBetBuilder: false,
    skinLogoUrl: "",
    competitorsInOutcome: false,
    competitorsNameInMarket: false,
    chooseThemeMode: false,
    theme: 'dark',
    enableB2b: false,
    enableB2bRefresh: true,
    // KEY live re-apply — see keyLiveReapply.service.js and SkinConfigRepository.
    // When true, the socket ODDS_CHANGE_LIVE handler re-runs the KEY math on
    // the affected market group after updating the raw provider value.
    enableKeyEvaluationLive: false,
    // Safety-net cap (points-of-percentage) applied during the live re-apply.
    // Mirrors the server-side value used by KeyHierarchyResolverBatch. `null`
    // = no cap (client always re-applies).
    keyLoosenLimitPp: null,
    dynamicMarketToView: false,
    colToShowInDetail: null,
    // Per-platform badge overrides (early payout / cashout), admin-configured
    // via rocky-admin, fetched fire-and-forget from GET /v3/badge-icons/:platformId
    // in main.js. Raw shape from the API: { earlyPayout: {...}, cashout: {...} }.
    // Empty object = nothing fetched yet / fetch failed → getBadgeIconConfig
    // falls back to today's look (enabled:false, size:16, text:{}).
    badgeIconsConfig: {},
    showSirplayLicence: null
};

const getters = {
    getMarketConfig: state => state.marketConfig,
    getName: state => {
        return state.name;
    },
    getUrlApi: state => {
        return state.urlApi;
    },
    getBetApiUrl: state => {
        return state.betApiUrl;
    },
    getUrlRules: state => {
        return state.urlRules;
    },
    getPlatformId: state => {
        return state.platform_id;
    },
    getToken: state => {
        return state.token;
    },
    getLanguage: state => {
        return state.language;
    },
    getSnackbar: state => {
        return state.snackbar
    },
    getSnackbarText: state => {
        return state.snackbar_text
    },
    getPlatformSettings: state => {
        return state.platform_settings
    },
    getResults: state => {
        return state.results
    },
    getBanners: state => {
        return state.banners
    },
    getShowQuickbet: state => {
        return state.showquickbet
    },
    getEventDay: state => {
        return state.eventday
    },
    getCashout: state => {
        return state.cashout
    },
    getCashoutLive: state => {
        return state.cashoutlive
    },
    getBetFreeze: state => {
        return state.betFreeze
    },
    getNextEvent: state => {
        return state.nextevent
    },
    getVoidAsLose: state => {
        return state.voidAsLose
    },
    getElectron: state => {
        return state.electron
    },
    getIcon: state => {
        return state.icon
    },
    getGameConsole: state => {
        return state.gameConsole
    },
    getStreamLive: state => {
        return state.stream_live
    },
    getEnableCentralBanner: state => {
        return state.enable_central_banner
    },
    getFeaturedTournamentAutoLoad: state => {
        return state.featuredTournamentAutoLoad
    },
    getFeaturedTournamentWidget: state => {
        return state.featuredTournamentWidget
    },
    getFeaturedTournamentsInfo: state => {
        return state.featuredTournamentsInfo
    },
    getProgramOpen: state => {
        return state.programOpen;
    },
    getShortCode: state => {
        return state.shortCode;
    },
    getEnableClearCartAtPlaceBet: state => {
        return state.enableClearCartAtPlaceBet
    },
    getEnabledTaxOnWon: state => {
        return state.enabledTaxOnWon
    },
    getPercentageTaxValueOnWon: state => {
        return state.percentageTaxValueOnWon
    },
    getEnableAgencyCanPlayForUser: state => {
        return state.enableAgencyCanPlayForUser
    },
    getEnableAgencyAutoRecharge: state => {
        return state.enableAgencyAutoRecharge
    },
    getEnableCashierCanPlayForUser: state => {
        return state.enableCashierCanPlayForUser
    },
    getEnableAgencyCashout: state => {
        return state.enableAgencyCashout
    },
    getEnableCashierCashout: state => {
        return state.enableCashierCashout
    },
    getEnableTerminalCashout: state => {
        return state.enableTerminalCashout
    },
    getEnableMobileBottomToolbar: state => {
        return state.enableMobileBottomToolbar
    },
    getExplodeMarketOnMobileDevice: state => {
        return state.explodeMarketOnMobileDevice
    },
    getProxyUrl: state => {
        return state.proxyUrl;
    },
    getWebsite: state => {
        return state.website;
    },
    getEnableAutoRecharge: state => {
        return state.enableAutoRecharge
    },
    getCustomerId: state => {
        return state.customerId
    },
    getShowMultiplicityLegendMobile: state => {
        return state.showMultiplicityLegendMobile
    },
    getEnableTreeWithPlayerOutcomes: state => {
        return state.enableTreeWithPlayerOutcomes
    },
    quickBetEnabled: state => {
        return state.quickBetEnabled
    },
    getAllowIntegralLiveBet: state => {
        return state.allowIntegralLiveBet
    },
    getCashoutPollIntervalMs: state => state.cashoutPollIntervalMs,
    getLivePollingIntervalMs: state => state.livePollingIntervalMs,
    getFinishedEventRemovalMs: state => state.finishedEventRemovalMs,
    getLiveScorePollingIntervalMs: state => state.liveScorePollingIntervalMs,
    getLiveDetailOddsRefreshIntervalMs: state => state.liveDetailOddsRefreshIntervalMs,
    getEnableEarlyPayout: state => state.enableEarlyPayout,
    getEnableMostPlayedWidget: state => state.enableMostPlayedWidget,
    getEnableUserTracking: state => state.enableUserTracking,
    getEnableNextEventsWidget: state => state.enableNextEventsWidget,
    getEnableStartingSoonWidget: state => state.enableStartingSoonWidget,
    getUiPersonalizationLeft: state => state.uiPersonalizationLeft,
    getUiPersonalizationCenter: state => state.uiPersonalizationCenter,
    getUiPersonalizationRight: state => state.uiPersonalizationRight,
    getUiPersonalizationGeneral: state => state.uiPersonalizationGeneral,
    getTimeFilterSteps: state => {
        const DEFAULT_STEPS = [3, 6, 12, 24];
        const ALLOWED_STEPS = [3, 6, 12, 24, 48, 72];
        const steps = state.timeFilterSteps;
        if (!Array.isArray(steps) || steps.length === 0) return DEFAULT_STEPS;
        const filtered = steps.filter(s => ALLOWED_STEPS.includes(+s));
        return filtered.length > 0 ? filtered : DEFAULT_STEPS;
    },
    getMobileKeypadType: state => state.mobileKeypadType,
    getShowParticipantLogos: state => state.showParticipantLogos,
    getShowTournamentLogos: state => state.showTournamentLogos,
    getCompetitorsInOutcome: state => state.competitorsInOutcome,
    getCompetitorsNameInMarket: state => state.competitorsNameInMarket,
    getChooseThemeMode: state => state.chooseThemeMode,
    getTheme: state => state.theme,


    // Getter per il numero massimo di eventi nella preview Live
    getLivePreviewMaxEvents: (state) => {
        return state.livePreviewMaxEvents || 100;
    },

    // Getter per il numero massimo di mercati nel dettaglio Live
    getLiveDetailMaxMarkets: (state) => {
        return state.liveDetailMaxMarkets || 500;
    },

    // Getter per il numero massimo di eventi nella preview Prematch (Vetrina)
    getPrematchPreviewMaxEvents: (state) => {
        return state.prematchPreviewMaxEvents || 15;
    },

    // Getter per il numero massimo di mercati nel dettaglio Prematch
    getPrematchDetailMaxMarkets: (state) => {
        return state.prematchDetailMaxMarkets || 150;
    },

    getMostPlayedMaxEventsForPage: (state) => state.mostPlayedMaxEventsForPage || 10,
    getNextEventsMaxEventsForPage: (state) => state.nextEventsMaxEventsForPage || 10,
    getStartingSoonMaxEventsForPage: (state) => state.startingSoonMaxEventsForPage || 10,
    getLiveNowPreviewMaxEventsForPage: (state) => state.liveNowPreviewMaxEventsForPage || 10,
    getMaxMixedEventsForPage: (state) => state.maxMixedEventsForPage || 50,
    getTimeToWaitToCallTournamentLive: (state) => state.timeToWaitToCallTournamentLive || 5000,
    getEnableQuickBetOnlyForAgency: (state) => state.enableQuickBetOnlyForAgency || false,
    getEnableBetBuilder: (state) => state.enableBetBuilder,
    getEnableLiveBetBuilder: (state) => state.enableLiveBetBuilder,
    getSkinLogoUrl: (state) => state.skinLogoUrl,
    getB2bEnabled: (state) => state.enableB2b,
    // Only meaningful when B2B itself is on. Skin can force the flag to false
    // to keep users permanently logged in; a missing value defaults to true.
    getB2bRefreshEnabled: (state) => state.enableB2b === true && state.enableB2bRefresh !== false,
    // KEY live re-apply flags — consumed by keyLiveReapply.service.
    getEnableKeyEvaluationLive: (state) => state.enableKeyEvaluationLive === true,
    getKeyLoosenLimitPp: (state) => state.keyLoosenLimitPp,
    getDynamicMarketToView: (state) => state.dynamicMarketToView,
    getColToShowInDetail: (state) => state.colToShowInDetail,
    // Function-getter: settings/getBadgeIconConfig(badgeKey, defaultSize = 16)
    // -> { enabled, size, text, imageEnabled, imageUrl } with safe defaults
    // baked in (today's look) when nothing was fetched yet or the key is
    // absent from the response.
    // `size` has no server-side default (see rocky-api's model comment: no
    // single number is "unset" for every badgeKey/render site) — the caller
    // supplies its OWN natural default via `defaultSize`. earlyPayout/cashout
    // (FeatureBadge.vue) never pass it, so they keep the original 16px
    // default untouched; betBuilder's tab-pill sites pass their own (24 on
    // classic, 35 on terminal/american) so an unconfigured badge keeps its
    // existing native width instead of collapsing to an unrelated default.
    getBadgeIconConfig: (state) => (badgeKey, defaultSize = 16) => {
        const cfg = state.badgeIconsConfig?.[badgeKey];
        return {
            enabled: cfg?.enabled === true,
            size: cfg?.size ?? defaultSize,
            text: cfg?.text ?? {},
            imageEnabled: cfg?.imageEnabled === true,
            imageUrl: cfg?.imageUrl ?? null
        };
    },
    getShowSirplayLicence: (state) => state.showSirplayLicence
};

const actions = {
    async setName(context, payload) {
        context.commit('SET_NAME', payload);
    },

    async setUrlApi(context, payload) {
        context.commit('SET_URL_API', payload);
    },

    async setBetApiUrl(context, payload) {
        context.commit('SET_BET_API_URL', payload);
    },

    async setUrlRules(context, payload) {
        context.commit('SET_URL_RULES', payload);
    },

    async setPlatformId(context, payload) {
        context.commit('SET_PLATFORM_ID', payload);
    },

    async setToken(context, payload) {
        context.commit('SET_TOKEN', payload);
    },
    async setIcon(context, payload) {
        context.commit('SET_ICON', payload);
    },

    async setLanguage(context, payload) {
        context.commit('SET_LANGUAGE', payload);
    },

    async setSnackbar(context, payload) {
        context.commit('SET_SNACKBAR', payload);
    },

    async setSnackbarText(context, payload) {
        context.commit('SET_SNACKBAR_TEXT', payload);
    },

    async setPlatformSettings(context, payload) {
        context.commit('SET_PLATFORM_SETTINGS', payload);
    },
    async setResults(context, payload) {
        context.commit('SET_RESULTS', payload);
    },
    async setBanners(context, payload) {
        context.commit('SET_BANNERS', payload);
    },
    async setShowQuickbet(context, payload) {
        context.commit('SET_SHOW_QUICKBET', payload); // true for  move directly to quick bet page for agency
    },
    async setVoidAsLose(context, payload) {
        context.commit('SET_VOID_AS_LOSE', payload);
    },

    async setElectron(context, payload) {
        context.commit('SET_ELECTRON', payload);
    },

    async setStreamLive(context, payload) {
        context.commit('SET_STREAM_LIVE', payload);
    },

    //deprecated OLD API TODO remove me when ready
    async fetchFeaturedTournaments(context, payload) {
        //todo DIO CANE STOP TO UNCOMMENT ME !!!
        //
        // const platformId = context.rootGetters['settings/getPlatformId'];
        // const url = `${context.rootGetters['settings/getUrlApi']}/tournaments/featured/` + platformId + '?language=' + context.rootGetters['settings/getLanguage'];
        //
        // if (platformId != null) {
        //     return await axios.get(url,
        //         {'headers': {'Authorization': `Bearer ${context.rootGetters['settings/getToken']}`}});
        // }
    },
    async setStatusBannerCentral(context, payload) {
        context.commit('SET_ENABLE_CENTRAL_BANNER_STATUS', payload);
    },
    async setFeaturedTournamentsInfo(context, payload) {
        context.commit('SET_FEATURED_TOURNAMENTS_INFO', payload);
    },
    async setProgramOpen(context, payload) {
        context.commit('SET_PROGRAM_OPEN', payload);
    },

    async setEnableAgencyCanPlayForUser(context, payload) {
        context.commit('SET_AGENCY_CAN_PLAY_FOR_USER', payload)
    },

    async setExplodeMarketsOnMobileDevice(context, payload) {
        context.commit('SET_EXPLODE_MARKETS_ON_MOBILE_DEVICE', payload);
    },
    async setProxyUrl(context, payload) {
        context.commit('SET_PROXY_URL', payload);
    },
    async setWebsiteUrl(context, payload) {
        context.commit('SET_WEBSITE_URL', payload);
    },
    async setEnableAutoRecharge(context, payload) {
        context.commit('SET_ENABLE_AUTO_RECHARGE', payload)
    },
    async setCustomerId(context, payload) {
        context.commit('SET_CUSTOMER_ID', payload)
    },
    async setQuickBetEnabled(context, payload){
        context.commit('SET_QUICK_BET_ENABLED', payload)
    },
    async setEnableQuickBetOnlyForAgency(context, payload){
        context.commit('SET_ENABLE_QUICK_BET_ONLY_FOR_AGENCY', payload)
    },
    async setSkinLogoUrl(context, payload){
        context.commit('SET_SKIN_LOGO_URL', payload)
    },
    async setCompetitorsInOutcome(context, payload){
        context.commit('SET_COMPETITORS_IN_OUTCOME', payload)
    },
    async setCompetitorsNameInMarket(context, payload){
        context.commit('SET_COMPETITORS_NAME_IN_MARKET', payload)
    },
    async setChooseThemeMode(context, payload){
        context.commit('SET_CHOOSE_THEME_MODE', payload)
    },
    async setTheme(context, payload){
        context.commit('SET_THEME', payload)
    },
    async setDynamicMarketToView(context, payload) {
        context.commit('SET_DYNAMIC_MARKET_TO_VIEW', payload)
    },
    async setColToShowInDetail(context, payload) {
        context.commit('SET_COL_TO_SHOW_IN_DETAIL', payload)
    },
    async setShowSirplayLicence(context, payload) {
        context.commit('SET_SHOW_SIRPLAY_LICENCE', payload)
    },
    async fetchMyPrintTemplates(context, payload) {

        const platformId = payload;
        const url = `${context.rootGetters['settings/getUrlApi']}/platforms/${platformId}/prints/templates`;

        return await axios.get(`${url}`, {'headers': {'Authorization': `Bearer ${context.rootGetters['settings/getToken']}`}})
            .then(async (res) => {
                return res.data;
            })
            .catch((err) => {
                console.log(err);
            });
    }
};

const mutations = {
    SET_NAME: (state, value) => {
        state.name = value;
    },
    SET_URL_API: (state, value) => {
        state.urlApi = value;
    },
    SET_BET_API_URL: (state, value) => {
        state.betApiUrl = value;
    },
    SET_URL_RULES: (state, value) => {
        state.urlRules = value;
    },
    SET_PLATFORM_ID: (state, value) => {
        state.platform_id = value;
    },
    SET_TOKEN: (state, value) => {
        state.token = value;
    },
    SET_LANGUAGE: (state, value) => {
        state.language = value;
    },
    SET_SNACKBAR: (state, value) => {
        state.snackbar = value;
    },
    SET_SNACKBAR_TEXT: (state, value) => {
        state.snackbar_text = value;
    },
    SET_PLATFORM_SETTINGS: (state, value) => {
        state.platform_settings = value != null ? value : {};
    },
    SET_RESULTS: (state, value) => {
        state.results = value != null ? value : [];
    },
    SET_BANNERS: (state, value) => {
        state.banners = [];
        state.banners = value;
    },
    SET_SHOW_QUICKBET: (state, value) => {
        state.showquickbet = value;
    },
    SET_ICON: (state, value) => {
        state.icon = value;
    },
    SET_EVENT_DAY: (state, value) => {
        state.eventday = value;
    },
    SET_CASH_OUT: (state, value) => {
        state.cashout = value != null ? value : false;
    },
    SET_CASH_OUT_LIVE: (state, value) => {
        state.cashoutlive = value != null ? value : false;
    },
    SET_BET_FREEZE: (state, value) => {
        state.betFreeze = value === true;
    },
    SET_NEXT_EVENT: (state, value) => {
        state.nextevent = value;
    },
    SET_VOID_AS_LOSE: (state, value) => {
        state.voidAsLose = value;
    },
    SET_ELECTRON: (state, value) => {
        state.electron = value;
    },
    SET_GAME_CONSOLE: (state, value) => { //todo mock for game console american
        state.gameConsole = value != null ? value : 'default';
    },
    SET_STREAM_LIVE: (state, value) => {
        state.stream_live = value != null ? value : false;
    },
    SET_ENABLE_CENTRAL_BANNER_STATUS: (state, value) => {
        state.enable_central_banner = value;
    },

    SET_FEATURED_TOURNAMENT_AUTOLOAD: (state, value) => {
        state.featuredTournamentAutoLoad = value;
    },

    SET_FEATURED_TOURNAMENT_WIDGET: (state, value) => {
        state.featuredTournamentWidget = value;
    },
    SET_FEATURED_TOURNAMENTS_INFO: (state, value) => {
        state.featuredTournamentsInfo = value;
    },
    SET_PROGRAM_OPEN: (state, value) => {
        state.programOpen = value;
    },
    SET_SHORT_CODE: (state, value) => {
        state.shortCode = value != null ? value : false;
    },
    SET_ENABLE_CLEAR_CART_AT_PLACE_BET: (state, value) => {
        state.enableClearCartAtPlaceBet = value != null ? value : false
    },
    SET_ENABLE_TAX_ON_WON: (state, value) => {
        state.enabledTaxOnWon = value != null ? value : false
    },

    SET_PERCENTAGE_TAX_VALUE_ON_WON: (state, value) => {

        if (state.enabledTaxOnWon === true) {
            state.percentageTaxValueOnWon = value != null && +value >= 0 ? value : 0
        } else {
            state.percentageTaxValueOnWon = 0
        }

    },

    SET_AGENCY_CAN_PLAY_FOR_USER: (state, value) => {
        state.enableAgencyCanPlayForUser = value != null ? value : false
    },
    // Only an explicit true enables it: null, undefined and any other value are false
    SET_ENABLE_AGENCY_AUTO_RECHARGE: (state, value) => {
        state.enableAgencyAutoRecharge = value === true
    },
    // Only an explicit true enables it: null, undefined and any other value are false
    SET_CASHIER_CAN_PLAY_FOR_USER: (state, value) => {
        state.enableCashierCanPlayForUser = value === true
    },
    SET_ENABLE_AGENCY_CASHOUT: (state, value) => {
        state.enableAgencyCashout = value != null ? value : false
    },
    SET_ENABLE_CASHIER_CASHOUT: (state, value) => {
        state.enableCashierCashout = value != null ? value : false
    },
    SET_ENABLE_TERMINAL_CASHOUT: (state, value) => {
        state.enableTerminalCashout = value != null ? value : false
    },
    SET_ENABLE_MOBILE_BOTTOM_TOOLBAR: (state, value) => {
        state.enableMobileBottomToolbar = value != null ? value : false
    },

    SET_EXPLODE_MARKETS_ON_MOBILE_DEVICE: (state, value) => {
        state.explodeMarketOnMobileDevice = value != null ? value : false
    },
    SET_PROXY_URL: (state, value) => {
        state.proxyUrl = value != null ? value : null
    },
    SET_WEBSITE_URL: (state, value) => {
        state.website = value != null ? value : null
    },
    SET_ENABLE_AUTO_RECHARGE: (state, value) => {
        state.enableAutoRecharge = value != null ? value : false
    },
    SET_CUSTOMER_ID: (state, value) => {
        state.customerId = value != null ? value : null;
    },
    SET_SHOW_MULTIPLICITY_LEGEND_ON_MOBILE_DEVICE: (state, value) => {
        state.showMultiplicityLegendMobile = value != null ? value : false
    },
    SET_ENABLE_TREE_WITH_PLAYER_OUTCOMES: (state, value) => {
        state.enableTreeWithPlayerOutcomes = value != null ? value : false
    },
    SET_QUICK_BET_ENABLED: (state, value) => {
        state.quickBetEnabled = value != null ? value : false
    },
    SET_ALLOW_INTEGRAL_LIVE_BET: (state, value) => {
        state.allowIntegralLiveBet = value != null ? value : false
    },
    SET_CASHOUT_POLL_INTERVAL_MS: (state, value) => {
        state.cashoutPollIntervalMs = value != null && +value > 0 ? +value : 60000
    },
    SET_LIVE_POLLING_INTERVAL_MS: (state, value) => {
        state.livePollingIntervalMs = value != null && +value > 0 ? +value : 45000
    },
    SET_FINISHED_EVENT_REMOVAL_MS: (state, value) => {
        state.finishedEventRemovalMs = value != null && +value > 0 ? +value : 300000
    },
    SET_LIVE_SCORE_POLLING_INTERVAL_MS: (state, value) => {
        const MIN = 5000;
        state.liveScorePollingIntervalMs = value != null && +value >= MIN ? +value : 10000
    },
    SET_LIVE_DETAIL_ODDS_REFRESH_INTERVAL_MS: (state, value) => {
        const MIN = 15000;
        state.liveDetailOddsRefreshIntervalMs = value != null && +value >= MIN ? +value : 45000
    },
    SET_ENABLE_EARLY_PAYOUT: (state, value) => {
        state.enableEarlyPayout = value != null ? value : true
    },
    SET_ENABLE_MOST_PLAYED_WIDGET: (state, value) => {
        state.enableMostPlayedWidget = value != null ? value : true
    },
    SET_ENABLE_USER_TRACKING: (state, value) => {
        state.enableUserTracking = value != null ? value : false
    },
    SET_ENABLE_NEXT_EVENTS_WIDGET: (state, value) => {
        state.enableNextEventsWidget = value != null ? value : true
    },
    SET_ENABLE_STARTING_SOON_WIDGET: (state, value) => {
        state.enableStartingSoonWidget = value != null ? value : true
    },
    SET_UI_PERSONALIZATION_LEFT: (state, value) => {
        state.uiPersonalizationLeft = Array.isArray(value) ? value : null
    },
    SET_UI_PERSONALIZATION_CENTER: (state, value) => {
        state.uiPersonalizationCenter = Array.isArray(value) ? value : null
    },
    SET_UI_PERSONALIZATION_RIGHT: (state, value) => {
        state.uiPersonalizationRight = Array.isArray(value) ? value : null
    },
    SET_UI_PERSONALIZATION_GENERAL: (state, value) => {
        state.uiPersonalizationGeneral = Array.isArray(value) ? value : null
    },
    SET_TIME_FILTER_STEPS: (state, value) => {
        state.timeFilterSteps = Array.isArray(value) ? value : null
    },
    SET_MOBILE_KEYPAD_TYPE: (state, value) => {
        state.mobileKeypadType = value ?? null;
    },
    SET_SHOW_PARTICIPANT_LOGOS: (state, value) => {
        state.showParticipantLogos = value !== false;
    },
    SET_SHOW_TOURNAMENT_LOGOS: (state, value) => {
        state.showTournamentLogos = value !== false;
    },

    SET_LIVE_PREVIEW_MAX_EVENTS(state, val) { state.livePreviewMaxEvents = val; },
    SET_LIVE_DETAIL_MAX_MARKETS(state, val) { state.liveDetailMaxMarkets = val; },
    SET_PREMATCH_PREVIEW_MAX_EVENTS(state, val) { state.prematchPreviewMaxEvents = val; },
    SET_PREMATCH_DETAIL_MAX_MARKETS(state, val) { state.prematchDetailMaxMarkets = val; },
    SET_MOST_PLAYED_MAX_EVENTS_FOR_PAGE(state, val) { state.mostPlayedMaxEventsForPage = val; },
    SET_NEXT_EVENTS_MAX_EVENTS_FOR_PAGE(state, val) { state.nextEventsMaxEventsForPage = val; },
    SET_STARTING_SOON_MAX_EVENTS_FOR_PAGE(state, val) { state.startingSoonMaxEventsForPage = val; },
    SET_LIVE_NOW_PREVIEW_MAX_EVENTS_FOR_PAGE(state, val) { state.liveNowPreviewMaxEventsForPage = val; },
    SET_MAX_MIXED_EVENTS_FOR_PAGE(state, val) { state.maxMixedEventsForPage = val; },
    SET_TIME_TO_WAIT_TO_CALL_TOURNAMENT_LIVE(state, val) { state.timeToWaitToCallTournamentLive = val; },
    SET_ENABLE_QUICK_BET_ONLY_FOR_AGENCY(state, val) { state.enableQuickBetOnlyForAgency = val; },
    SET_ENABLE_BET_BUILDER(state, val) { state.enableBetBuilder = val === true; },
    SET_ENABLE_LIVE_BET_BUILDER(state, val) { state.enableLiveBetBuilder = val === true; },
    SET_SKIN_LOGO_URL(state, val) { state.skinLogoUrl = val; },
    SET_COMPETITORS_IN_OUTCOME(state, val) { state.competitorsInOutcome = val; },
    SET_COMPETITORS_NAME_IN_MARKET(state, val) { state.competitorsNameInMarket = val === true; },
    SET_CHOOSE_THEME_MODE(state, val) { state.chooseThemeMode = val === true; },
    SET_THEME(state, val) { state.theme = (val === 'light' || val === 'dark') ? val : 'dark'; },
    SET_B2B_ENABLED(state, val) { state.enableB2b = val === true; },
    // Server-controlled: only `false` disables the periodic /b2b refresh + ping.
    // Missing/undefined → keep the default (true).
    SET_B2B_REFRESH_ENABLED(state, val) { state.enableB2bRefresh = val !== false; },
    // KEY live re-apply flags — set at boot from applySkinSettings after
    // the /v3/skins-config/platform-config response arrives.
    SET_ENABLE_KEY_EVALUATION_LIVE(state, val) { state.enableKeyEvaluationLive = val === true; },
    SET_KEY_LOOSEN_LIMIT_PP(state, val) {
        // Accept both `null` (no cap) and finite numbers. Anything else falls back to null.
        const n = Number(val);
        state.keyLoosenLimitPp = Number.isFinite(n) ? n : null;
    },
    SET_DYNAMIC_MARKET_TO_VIEW(state, val) { state.dynamicMarketToView = val === true; },
    SET_COL_TO_SHOW_IN_DETAIL(state, val) { state.colToShowInDetail = val != null ? val : null; },
    // Per-platform badge overrides — see state.badgeIconsConfig above.
    SET_BADGE_ICONS_CONFIG(state, val) {
        state.badgeIconsConfig = (val && typeof val === 'object') ? val : {};
    },
    SET_SHOW_SIRPLAY_LICENCE(state, val) { state.showSirplayLicence = val != null ? val : null; },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
